var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_699_11717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 8.28027L0 12.0003L3.72 10.8003L1.2 8.28027Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89528 1.56323L2.04053 7.41797L4.58608 9.96351L10.4408 4.10878L7.89528 1.56323Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8183 1.86L10.1383 0.18C9.8983 -0.06 9.5383 -0.06 9.2983 0.18L8.7583 0.72L11.2783 3.24L11.8183 2.7C12.0583 2.46 12.0583 2.1 11.8183 1.86Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_699_11717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d7d78a1b7ab031e4abc36a12bffc7f1c.svg";
export { ForwardRef as ReactComponent };